import { z } from 'zod';

import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';

// Liquidation method
// - short sale
// - foreclosure third party sale

export const LiquidationRecord = z.object({
  processedDate: zodJSPlainDate,
  soldPrice: z.number(),
  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
});
export type LiquidationRecord = z.infer<typeof LiquidationRecord>;

export const LiquidationRecordInput = LiquidationRecord.pick({
  processedDate: true,
  soldPrice: true,
});
export type LiquidationRecordInput = z.infer<typeof LiquidationRecordInput>;
